import { RestorePasswordForm } from '@bvi/dashboard/feature/auth/ui/restore-password-form';

export const RestorePasswordPage = () => {
  return <RestorePasswordForm />;
};
